import { render, staticRenderFns } from "./PrinterHelpButton.vue?vue&type=template&id=9cf807f2&scoped=true"
import script from "./PrinterHelpButton.vue?vue&type=script&lang=js"
export * from "./PrinterHelpButton.vue?vue&type=script&lang=js"
import style0 from "./PrinterHelpButton.vue?vue&type=style&index=0&id=9cf807f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf807f2",
  null
  
)

export default component.exports